import React from "react";
import Button from "@/components/button/Button";
import Icon from "@/components/icon/Icon";
import Thumbnail from "@/components/thumbnail/Thumbnail";
const ImagePreview = (props) => {
  const { onRemove, image } = props;
  return /* @__PURE__ */ React.createElement("div", { className: "image-preview" }, /* @__PURE__ */ React.createElement(Thumbnail, { url: image.thumbnailUrl || image.image_url }), /* @__PURE__ */ React.createElement(Button, { color: "removable", onClick: () => onRemove(image) }, /* @__PURE__ */ React.createElement(Icon, { icon: "xContained" })));
};
export default ImagePreview;
